<template>
  <div class="customer-swiper w-full h-full" :style="styles"></div>
</template>

<script>
// import { slider, slideritem } from 'vue-concise-slider'

export default {
  components: {
    // slider,
    // slideritem
  },
  props: {
    swiperPages: Array,
  },
  data() {
    return {
      currenIndex: 0,
    }
  },
  computed: {
    styles() {
      return {
        backgroundImage: `url(${this.swiperPages[this.currenIndex].image})`
      }
    }
  },
  methods: {
    slide() {},
    onTap() {},
    onInit() {},
  },
  mounted() {
    setInterval(() => {
      if(this.currenIndex >= this.swiperPages.length - 1) {
        this.currenIndex = 0;
      } else {
        this.currenIndex += 1;
      }
    }, 5000)
  }
}
</script>

<style>
.customer-swiper{
    background-size: cover;
    transition: all 1s ease;
}
</style>
